
 
import FsBorderLayout from './components/FsBorderLayout.js';

import FsBuildTop from './components/appBuild/FsBuildTop.js'; 
import FsBuildLeft from './components/appBuild/FsBuildLeft.js';
import FsComponentPropertyRight from './components/appBuild/FsComponentPropertyRight.js'

import FsBuildTopReport from './components/appBuild/FsBuildTopReport.js';
import FsComponentPropertyRightReport from './components/appBuild/FsComponentPropertyRightReport.js'

import FsBuildLeftActivity from './components/appBuild/activity/FsBuildLeftActivity.js';
import FsBuildTopActivity from './components/appBuild/activity/FsBuildTopActivity.js';
import FsComponentPropertyRightActivity from './components/appBuild/activity/FsComponentPropertyRightActivity.js'

import FsBuildCenter from './components/appBuild/FsBuildCenter.js';
 




 

import FsDrager from './components/appBuild/FsDrager.js'
import FsRightDrawer from './components/render/FsRightDrawer.js'
import FsWinManager from './components/render/FsWinManager.js'
import {  Spin ,Tabs} from '@jd/find-react';
import React from 'react';
 
import KeeVue from './components/base/KeeVue.js';
import KinerGuideView from './KinerGuide/KinerGuideView.js';

import $ from 'jquery';

const { TabPane } = Tabs;


 


// var pid = 'cityManager/tableList';
// var appId = '2021031708594945141281972480-CSY';
// var tid = "2021022615165624282776624050-city26";
// var keyName = "city26";

// var staticUrl = "http://dev-jinrong.xjoycity.com/ggyw-static-web";

// var userRootUri = "";
// var webUrl="http://ex-demo.xjoycity.com/demo26";

// var initSelectPageCode = "tableList";

class FsBuild extends KeeVue {
	constructor(props) {
		super(props);
		this.state = {
			appId: '',
			code: 'cityDriverInfo/',

			keePage: null,
			components: [],
			activeComponent: null,
			controller: {
				showSource: false,
				vueSource: "",
				showCenterPage:'huabu'
			},
			vueJsArray:[],
			vueloadedCount:0,
			mainInfo:null,
			showCenterPage:'huabu',
			
			right:(window.isActivity?'500px':'300px'),
			left:'300px',
			showDevButton:false,
			
		}

		this.myRef = React.createRef();

	}
	componentWillMount() {
		
		this.fileCount = 1;
	}

	

	componentDidMount() {

		console.log("app 加载完成")
		if (this.b) {
			// this.b.bindThis(this.b);
			console.log(this.b);

			//this.b.saveComponent();
		}
		
		window.devEditMode = true;
		
		
		$("body").css("overflow-y","hidden");
		
		window.closeShowDevBtn= true;
		
		// 用来标识当前的会话id
		window.jzhhid=this.getRandString();
			
			

		this.onEvent("right.changePage", this.onChangePage);

		//this.myRef.current.addEventListener("help", this.onHelp);
		this.onEvent("refresh", this.onRefresh);

		this.onEvent("redraw", () => this.setState(this.state));

		this.onEvent("showComponentProperty", this.onRightClick);
		this.onEvent("updateComponentProperty", this.onUpdateComponentProperty);
		
		this.onEvent("pageJsonValueChange",this.onPageJsonValueChange);
		
		this.onEvent("createState",this.onCreateState);
		
	 	document.addEventListener('keydown',this.onKeyDown);
		
		this.onEvent("showReact",()=> this.setState(this.state));
		
		this.onEvent("huanyuan",this.huanyuanState);
		
		this.onEvent("chongzuo",this.chongzuoState);
		
		this.onEvent("showHuaBu",()=>{
			this.state.showCenterPage = "huabu";
			this.state.controller.showCenterPage = "huabu";
			this.refresh();
		});
		
		document.addEventListener('keyup',(event)=>{
			console.log("up"+event.keyCode);
			if(!this.downKeys)
			{
				this.downKeys ={};
			}
			
			this.downKeys["key"+event.keyCode] =false;
			
		});
		
		
	
	
		
		
	  
	 
	 
	 // this.state.vueJsArray.push(window.rootUri+"/api/vueComponentJs/getServerBusinessCss?_t=4.20210427110643&tid="+window.tid+"");
	 
	 
	  var url = window.rootWebPath+"/clientConfig/getMap";
	   
	   // var url = window.location.protocol+"//"+window.location.host+"/clientConfig/getMap";
	 
	 
	  if(process.env.NODE_ENV=='development')
	  {
	 	window.rootUri=window.webUrl;
	 	url = window.webUrl+"/clientConfig/getMap";
	  }
	  else
	  {
	 	 window.rootUri=window.rootWebPath;
	  }
	  
	  let protocolStr = document.location.protocol;
	  if(protocolStr == "https:")
	  { 
	     window.rootUri = window.rootUri.replace("http://","https://");
	  }
	  else
	  {
	  	window.rootUri = window.rootUri.replace("https://","http://");
	  }
	  
	  
	  
	 this.doRequest(url,(ret)=>{
	 	window.tid = ret.tid;
	 	window.keyName = ret.keyName;
	 	this.state.clientConfig = ret;
		console.log("clientConfig/getMap::"+JSON.stringify(ret));
		if(ret)
		{
			window.tid = ret.tid;
			window.keyName = ret.keyName;
			// window.rootUri = ret.rootWebPath;
			window.rootClientWebPath = window.rootWebPath;
						 
			window.ClientInsConfig = ret;
			
			window.ServerConfig = ret;
			
			if(ret&&ret.gloabalMap)
			{
				for(let p in ret.gloabalMap)
				{
					if(process.env.NODE_ENV=='development'&&p=="webUrl")
					{
						continue;
					} 
					window[p] = ret.gloabalMap[p];
				} 
				
				
			}
			
			window.clientMap = ret;
			window.SERVER= ret;
			
			
			$("#root").addClass(ret.mainClassName);
			$("#win-manager-div").addClass(ret.mainClassName);
			
			
			
		}
		let protocolStr = document.location.protocol;
		if(protocolStr == "https:")
		{ 
		   window.rootUri = window.rootUri.replace("http://","https://");
		}
		else
		{
			window.rootUri = window.rootUri.replace("https://","http://");
		}
		
		
		window.allPropConfig={};
		
		// 加载Vue的js资源文件
		// this.state.vueJsArray.push(window.rootUri+"/mainFrame/config");
		 
		 
		 let  vueFileNames = "";
		 vueFileNames += "kee-string.vue"; 
		 vueFileNames += ",fs-icon.vue,fs-alert.vue,fs-pic-select.vue,fs-table-tree.vue"; 
		 vueFileNames += ",fs-tree.vue,fs-table.vue,fs-table-col.vue,"; 
		 vueFileNames += "fs-dropdown.vue,fs-select.vue,fs-cascader.vue,fs-upload.vue,fs-ztree.vue,fs-scroll.vue"; 
		 vueFileNames += ",fs-layout.vue,fs-tree-menu.vue,fs-text.vue,fs-button.vue,fs-view.vue"; 
		 vueFileNames += ",fs-pic.vue,fs-video.vue,fs-rect.vue,fs-form.vue,fs-tabs.vue,feas-page.vue,";
		 vueFileNames += ",fs-dialog.vue,fs-border-layout.vue,";
		 vueFileNames+= "fs-list.vue,fs-menu-item.vue,fs-win-manager.vue,"; 
		 vueFileNames+= "fs-box.vue,fs-card.vue,fs-color.vue,fs-code-editor.vue,fs-html-editor.vue";
		 	
		 	
		 	
		 	 
		 		if(window.location.host.indexOf("cms.xjoycity.com")!=-1)
		 		{
		 			let vueJs = vueFileNames.split(",");
		 			for(let item of vueJs)
		 			{
		 				if(item)
		 				{
		 					console.log("jiazai:"+window.rootWebPath+"/front/_vue/"+item.replace(".vue",".js")+"?_t="+window.PLATFORM_BUILD_VERSION+"&tid="+window.tid+"");
		 						this.state.vueJsArray.push(window.rootWebPath+"/front/_vue/"+item.replace(".vue",".js")+"?_t="+window.PLATFORM_BUILD_VERSION+"&tid="+window.tid+"");
		 					
		 				}
		 			}
		 			
		 		}
		 		else
		 		{
		 			// this.vueJsArray.push(window.rootUri+"/api/vueComponentJs/getByCombineJs?_t="+window.PLATFORM_BUILD_VERSION+"&tid="+window.tid+"");
		 			
		 			this.state.vueJsArray.push(window.rootUri+"/vResList/getByCombineJs?_t="+window.PLATFORM_BUILD_VERSION+"&tid="+window.tid+"");
		 			
		 		}
				
		 
		// this.state.vueJsArray.push(window.rootUri+"/keePage/getAllPropForm?_t=1614701720000&tid="+window.tid+"&keyName="+window.keyName+"&code=common-component");
		 // this.state.vueJsArray.push(window.rootUri+"/api/vueComponentJs/getByCombineJs?_t=4.20210427110643&tid="+window.tid+"");
		 // this.state.vueJsArray.push(window.rootUri+"/api/vueComponentJs/getByCombineJs?_t="+window.PLATFORM_BUILD_VERSION+"&tid="+window.tid+"");
		 //this.state.vueJsArray.push(window.rootUri+"/api/vueComponentJs/getServerBusinessJs?_t=4.20210427110643&tid="+window.tid+"");
		 //this.state.vueJsArray.push(window.rootUri+"/api/vueComponentJs/fsInput?_t=4.20210427110643&tid="+window.tid+"");
		
		 this.state.vueJsArray.push(window.rootWebPath+"/front/fs-input.js?_t="+window.BUILD_VERSION+"&tid="+window.tid+"");
		
		 this.state.vueJsArray.push(window.rootWebPath+"/front/fs-render.js?_t="+window.BUILD_VERSION+"&tid="+window.tid+"");
		 this.state.vueJsArray.push(window.rootWebPath+"/front/_js/js-formatter.js?_t="+window.BUILD_VERSION+"&tid="+window.tid+"");
		 
		 
		 
		 this.fileCount=this.state.vueJsArray.length+1;
		 
		 if (window.clientMap && window.clientMap.customCssUrl) {
		 	let cssUrls = window.clientMap.customCssUrl.split(",");
		 	this.fileCount += cssUrls.length;
		 }
		 
	 	
	 	// 然后获取用户信息，如果获取成功显示，如果获取失败，跳转到登录页面
	 	this.doRequest("/mainFrame/getMainInfo",(mainInfo)=>{
			
			if(mainInfo&&mainInfo.retData)
			{
				for(let p in mainInfo.retData)
				{
					if(p=='allDicts'||p=="userPermissions")
					{
						window[p] = JSON.parse(mainInfo.retData[p]);
					}
					else
					{
						window[p] = mainInfo.retData[p];
					} 
				}
			}
	 		
	 	 
	 		
	 		if(mainInfo.success)
	 		{
	 			// 获取成功
	 			
	 			window.document.title = mainInfo.retData.systemTitle;
	 			
				 window.loginedTokenNew=true;
				 
					 
				 
				// window._sign = mainInfo.retData._sign;
				// window._publicKey = mainInfo.retData.publicKey;
				// window._rsakey = mainInfo.retData.rsakey;
				
	 			//alert(JSON.stringify(this.state.mainInfo));
				
				var title = this.getUrlParameter("title");
		 
				this.doRequest("/jdccApp/getJdccAppByName?pid="+title,(app)=>{
					if(app.success)
					{
						window.appId = app.retData.id;
						window.appName = app.retData.name;
						
						 
						
						window.isReport = (app.retData.type==='REPORT');
						window.isActivity = (app.retData.type==='ACTIVITY');
						
						this.state.right=(window.isActivity?'500px':'300px');
						 this.state.left=(window.isActivity?'390px':'300px');
						window.document.title ="编辑"+app.retData.title;
							
						this.state.appId = app.retData.id;
						// 设置为开始
						this.state.mainInfo = mainInfo.retData;
						
						
						// 处理鼠标拖拽改变大小功能
						setTimeout(()=>{
								
							window.initResizeDiv("rightPartDiv",{
								maxW:800,
								minW:300,
								cb: (w,h)=>{
									this.state.right=w ;
									this.refresh();
								}
							});
							
							window.initResizeDiv("leftPartDiv",{
								maxW:550,
								minW:280,
								cb: (w,h)=>{
									this.state.left=w ;
									this.refresh();
								}
							});
							
						},1000);
						
						
						
						$.ajax({
							url: window.rootUri + "/jdccApp/getAppCssContent?appId="+window.appId+"&_t="+this.getRandString()+"&tid="+window.tid,
							cache: false,
							type: 'get',
							dataType: "html",
							data: { 
							},
							success: (str)=> { 
								 var nod = document.createElement("style");
								nod.type = "text/css";
								nod.id="appCssContent";
								if(nod.styleSheet) { //ie下  
									nod.styleSheet.cssText = str;
								} else {
									nod.innerHTML = str; //或者写成 nod.appendChild(document.createTextNode(str))  
								}
								//document.getElementsByTagName("head")[0].appendChild(nod);
								
								document.body.parentNode.appendChild(nod);
								this.refresh();
							  
							},
							error: function(XMLHttpRequest, textStatus, errorThrown) {
								 
								console.log("网络请求错误getAppCssContent")
								module.data = "";
							}
						});
						
						
						 
						
						//this.selfSetIcon(this.state.clientConfig.fsUrl+this.state.mainInfo.sys.logo);
						
					  
							if(this.state.mainInfo.sys.icon)
							{
								this.selfSetIcon(this.state.clientConfig.fsUrl+this.state.mainInfo.sys.icon);
							}
							else
							{
								if(ret.tabIcon)
								{
									this.selfSetIcon(ret.tabIcon);
								}
								else
								{
									this.selfSetIcon(this.state.clientConfig.fsUrl+this.state.mainInfo.sys.logo);
								}
							}
						 
						
						
						// 找到应用
						if(window.ServerConfig.websocketUrl&&this.state.appId)
						{
							// 开启socket监听模式，响应服务器的消息 
							let token = window.getCookie("token"); 
							let keyName = window.keyName;
							
							window.editorInfo = this.state.appId+":"+this.getRandString();
							 
							if(keyName)
							{
								token =  window.getCookie(keyName + "_token");
								this.connectWebSocket(ret.websocketUrl+'?wsUserId=editor:'+window.editorInfo+"&"+keyName+"_token="+token+"&tid="+window.tid)
							}
							else
							{
								this.connectWebSocket(ret.websocketUrl+'?wsUserId=editor:'+window.editorInfo+"&token="+token+"&tid="+window.tid)
							} 
							
						} 
						
						this.refresh();
					}
					else
					{
						this.state.appNotExists=true;
						this.refresh(); 
					}
				})
				
				
	 		}
	 		else
	 		{
	 			if(mainInfo.error==-100)
	 			{
					var fromPlatform = this.state.clientConfig.fromPlatform;
					
					if(!fromPlatform)
					{
						fromPlatform = "";
					}
					
				 
	 				var loginUrl = ret.passportUrl+"/login?fromPlatform="+fromPlatform+"&tid="+ret.tid+"&keyName="+ret.keyName;
	 				loginUrl+="&returnUrl="+window.location.href;
					
					window.loginUrl = loginUrl;
					
	 				window.location.href=loginUrl.replace("http:",document.location.protocol);;
	 				return ;
	 			}
	 		}
	 		
	 		
	 		this.state.vueJsArray.map((item,index)=>{
	 			this.loadJs(item,()=>{
	 				this.state.vueloadedCount++;
					this.refresh();
	 			});
	 		})
			
			if(window.clientMap.thirdLibs)
			{
				for(let i=0;i<window.clientMap.thirdLibs.length;i++)
				{
					console.log("load lib:"+window.clientMap.thirdLibs[i].url);
					if(window.clientMap.thirdLibs[i].name=='js')
					{
						this.loadJs(window.clientMap.thirdLibs[i].url,()=>{
							console.log("finish url:"+window.clientMap.thirdLibs[i].url);
						});
					}
					if(window.clientMap.thirdLibs[i].name=='css')
					{
						this.loadCss(window.clientMap.thirdLibs[i].url,()=>{
							console.log("finish url:"+window.clientMap.thirdLibs[i].url);
						});
					}
					
					if(window.clientMap.thirdLibs[i].name=='woff2'||window.clientMap.thirdLibs[i].name=='woff')
					{ 
						let content = "";
						content +="@font-face {  ";
						content +="    font-family: '"+window.clientMap.thirdLibs[i].title+"';  ";
						content +="    src: url('"+window.clientMap.thirdLibs[i].url+"') format('"+window.clientMap.thirdLibs[i].name+"');"; 
						content +="    font-weight: normal;  ";
						content +="    font-style: normal;  ";
						content +="}"; 
						let style = document.createElement('style');   
						// 为style元素添加CSS内容  
						style.innerHTML =  content; 
						// 将style元素添加到head元素中  
						document.head.appendChild(style); 
					}
					
				}
			}
			
			
			let protocolStr = document.location.protocol;
			if(protocolStr == "https:")
			{ 
			   window.rootUri = window.rootUri.replace("http://","https://");
			}
			
			// this.loadCss(window.rootUri+"/api/vueComponentJs/getByCombineCss?_t=4.20210825102000&tid="+window.tid+"",()=>{
			// 	console.log("done:css");
			// 	this.state.vueloadedCount++; 
			// 	this.refresh();
				
			// });
			 
			$.ajax({
				url: window.rootUri + "/api/vueComponentJs/getByAppBusinessCss?pt="+window.MAX_KEE_PAGE_TIME+"&tid="+window.tid,
				cache: true,
				type: 'get',
				dataType: "html",
				data: { 
				},
				success: (str)=> {
					
					this.state.vueloadedCount++;
					 var nod = document.createElement("style");
					nod.type = "text/css";
					if(nod.styleSheet) { //ie下  
						nod.styleSheet.cssText = str;
					} else {
						nod.innerHTML = str; //或者写成 nod.appendChild(document.createTextNode(str))  
					}
					//document.getElementsByTagName("head")[0].appendChild(nod);
					
					document.body.parentNode.appendChild(nod);
					this.refresh();
				  
				},
				error: function(XMLHttpRequest, textStatus, errorThrown) {
					 
					console.log("网络请求错误getByAppBusinessCss")
					module.data = "";
				}
			});
			
			
			
			// 增加用户自定义的css
			if(window.clientMap&&window.clientMap.customCssUrl)
			{
				let cssUrls = window.clientMap.customCssUrl.split(",");
				
				for(let ii=0;ii<cssUrls.length;ii++)
				{
					let cssUrl = cssUrls[ii];
					
				
				if(cssUrl.indexOf("http")!=0)
				{
					cssUrl = window.rootUri+cssUrl;
				}
				
				if(cssUrl.indexOf("?")==-1)
				{
					cssUrl+="?";
				}
				
				cssUrl+="&pt="+window.MAX_KEE_PAGE_TIME;
				
				$.ajax({
					url: cssUrl,
					cache: true,
					type: 'get',
					dataType: "html",
					data: { 
					},
					success: (str)=> {
						
						this.state.vueloadedCount++;
						 var nod = document.createElement("style");
						nod.type = "text/css";
						if(nod.styleSheet) { //ie下  
							nod.styleSheet.cssText = str;
						} else {
							nod.innerHTML = str; //或者写成 nod.appendChild(document.createTextNode(str))  
						}
						//document.getElementsByTagName("head")[0].appendChild(nod);
						
						document.body.parentNode.appendChild(nod);
						this.refresh();
					  
					},
					error: function(XMLHttpRequest, textStatus, errorThrown) {
						 
						console.log("网络请求错误getByAppBusinessCss");
						module.data = "";
					}
				});
				}
			}
			
			
			// 提前准备好icon列表
			this.doRequest("/sysPrivilege/getIconLibs", (list) => {
				// that.iconList = list; 
				window.alliconList = list;  
			});
			
			
			 
	 	 
	 	 
	 	})
	 })
	  
	 
	 
		


	}
	
	
	onUpdateComponentProperty = (event, selectComponent) => {


		var that = this;
		this.state.targetComponent = selectComponent;
		//setTimeout(()=>{
			this.sendEvent("updateComponentProperty2", event, selectComponent);
		//},30)
	

		this.setState(this.state);

	}
	onRightClick = (event, selectComponent) => {
		var that = this;

		if (selectComponent) {

		}

		this.state.targetComponent = selectComponent;
		setTimeout(()=>{
			this.sendEvent("showComponentProperty2", event, selectComponent);
		},30)
		
		this.setState(this.state);
	}
	
	onPageJsonValueChange=(newJsonArray)=>{
		console.log("build rec json chage")
		this.setComponentArray(newJsonArray,this.state.components);
		
		
		if( this.state.targetComponent)
		{
			//this.state.targetComponent ={};
			var target = this.getComponentById(this.state.targetComponent.id,this.state.components);
			
			this.state.targetComponent = target;
			 
			console.log(JSON.stringify(target));
			 
			//alert("fasong gegnxin");
			setTimeout(()=>{
				this.sendEvent("updateComponentProperty2", null, target);
			},100);
			
		}
		
		 
		
		this.refresh();
		
	}
	
	onKeyDown=(event)=>{
		
			console.log("down"+event.keyCode);
			if(!this.downKeys)
			{
				this.downKeys ={};
			}
			
			this.downKeys["key"+event.keyCode] =true;
			 
			if(!this.state.controller.showSource)
			{
				if(this.downKeys["key17"]&&this.downKeys["key90"] )
				{ 
					this.huanyuanState(); 
				} 
				
				if(this.downKeys["key17"]&&this.downKeys["key89"] )
				{
					this.chongzuoState();
				}
				
				if(this.downKeys["key46"])
				{ 
					if(document.activeElement&&document.activeElement.className)
					{
						
					
					}
					else
					{
						this.sendEvent("key.d");
					}
					
					
				}
			}
			
			
				console.log("down"+event.keyCode);
				if(!this.downKeys)
				{
					this.downKeys ={};
				}
				
				this.downKeys["key"+event.keyCode] =true;
				  
				if(this.downKeys["key17"] )
				{ 
					if(window.mainVueApp)
					{
						 this.state.showDevButton = !this.state.showDevButton;
						 this.refresh();
						 window.mainVueApp.sendEvent("showDevButton",this.state.showDevButton);
					}
					this.downKeys["key17"] = false;
				}  
			
			
			
			
			 
		
	}
	
	onCreateState=()=>{
		
		//alert("onCreateState")
		var pageString = JSON.stringify(this.state.keePage);
		if(!this.opStack)
		{
			this.opStack = [];
			this.opStack.push(pageString);
			this.stateIndex = 0;
			return ;
		}
		if(this.opStack[this.opStack.length-1]!=pageString)
		{
			this.opStack.push(pageString);
		}
		if(this.opStack.length>10)
		{
			this.opStack.remove(this.opStack[0]);
		}
		
		this.stateIndex = this.opStack.length-1;
		
		return ; 
	}
	
	huanyuanState=()=>{
		console.log("还原"+this.stateIndex)
		if(this.stateIndex>0)
		{
			this.stateIndex--;
			var keePage = JSON.parse(this.opStack[this.stateIndex]);
			
			this.sendEvent("setPage",keePage);
			
			// this.setState({
			// 	keePage:keePage,
			// 	components:keePage.components
			// }) 
		} 
	}
	
	chongzuoState=()=>{
		console.log("重做"+this.stateIndex+"  this.opStack.length:"+this.opStack.length)
		if( this.stateIndex<this.opStack.length-1)
		{
			this.stateIndex++;
			var keePage = JSON.parse(this.opStack[this.stateIndex]);
			
			this.sendEvent("setPage",keePage);
			
			// this.setState({
			// 	keePage:keePage,
			// 	components:keePage.components
			// }) 
		} 
	}
	
	
	getComponentById = (id, fromComponents)=>{
	
		for(var i = 0; i < fromComponents.length; i++) {
			var c = fromComponents[i];
	
			if(c.id == id) {
				return c;
			}
	
			if(typeof c.child != "undefined" && c.child != null && c.child.length > 0) {
				//console.log(JSON.stringify(c));
				var target = this.getComponentById(id, c.child);
				if(target != null)
					return target;
			}
	
			// 看 c 是否包含 component的坐标							 
	
		}
	
		return null;
	}
	
	
	setComponentArray=(newCompArray,targetCompArray)=>
	{
		// 先通过ID 找到这个组件
		
		if(newCompArray&&targetCompArray)
		{
			newCompArray.map((item,index)=>{
				targetCompArray.map((item2,index2)=>{
					if(item.id==item2.id)
					{
						this.copyComponentValue(item,item2);
					}
				})
			})
		}
		
		
		
		 
		
	}
	copyComponentValue=(src,target)=>{
		for(var p in src)
		{
			if(p!="child"&&p!="children"&&p!="cp"&&p!="style")
			{
				target[p] = src[p];
			}
			if(p=='cp' )
			{
				for(var c in src[p])
				{
					target[p][c] = src[p][c];
				}
			}
			if(p=="child")
			{
				this.setComponentArray(src[p],target[p]);
			}
			
		}
	}
	
	onRefresh = () => {
		//alert("收到refresh事件!");
		// setTimeout(()=>{
		//   this.setState(this.state);
		// },10)
		//this.setState(this.state);
	}
	onChangePage = (newPage) => {


		if (newPage == null) {
			this.state.keePage = null;
			this.state.components = [];
			return;
		}

		var that = this;

		// 先保存以前的值
		//that.keePage.vueSource = editor.getValue();

	

		//alert("开始改变值！"+that.keePage.isSelected)
		if (newPage && window.editor) {
			//{"row":26,"column":30}
			//alert(JSON.stringify(editor.selection.getCursor()));
			
			if(newPage.keePage.vueSource)
			{
				window.editor.setValue(newPage.keePage.vueSource);
			}
			else 
			{
				window.editor.setValue("");
			}
			
			window.editor.clearSelection();

			window.editor.moveCursorTo(0, 0);
		}

		//alert("完成改变值！")
		// that.state.keePage = newPage.keePage;
		// that.state.components = newPage.keePage.components;
		
		if(!newPage.keePage.actions)
		{
			newPage.keePage.actions=[];
		}
		
	
		
		

		if(this.state.keePage&&this.state.keePage.id==newPage.keePage.id)
		{
			// 需要记录上次的选中组件
			let selectArray = [];
			this.getOldSelectComponents(this.state.keePage.components,selectArray);
			
			console.log("当前选中组件:"+selectArray.length);
			
			let newSelectArray = [];
			this.setSelectComponents(newPage.keePage.components,selectArray,newSelectArray);
			
			if(newSelectArray&&newSelectArray.length==1)
			{  
				setTimeout(function () {
					that.sendEvent("selectComponent",newSelectArray[0]);
				}, 20);
			}  
			this.setState({
				keePage: newPage.keePage,
				components: newPage.keePage.components
			});
		}
		else
		{
			this.sendEvent("clearSelectState");
				
			this.setState({
				keePage: newPage.keePage,
				components: newPage.keePage.components
			});
			this.onCreateState();
		}
		
 

		setTimeout(function () {
			that.sendEvent("changePageType")
		}, 20);

		// setTimeout(function() {
		// 	that.sendEvent("changePageType")
		// }, 20);

	}
	
	getOldSelectComponents=(components,selectArray)=>{
		
		for(let i=0;i<components.length;i++)
		{
			if(components[i].isSelected)
			{
				console.log("当前选中组件:"+components[i].id+"--"+components[i].alias)
				selectArray.push(components[i]);
			}
			if(components[i].child)
			{
				this.getOldSelectComponents(components[i].child,selectArray);
			}
		}
		
	}
	
	setSelectComponents=(components,selectArray,newSelectArray)=>{
		
		for(let i=0;i<components.length;i++)
		{ 
			let isSelected = false; 
			for(let j=0;j<selectArray.length;j++)
			{
				if(components[i].id==selectArray[j].id)
				{
					isSelected = true;
					if(newSelectArray)
					{
						newSelectArray.push(components[i]);
					}
					else
					{
						console.log("newSelectArray null error")
					}
					
					break;
				}
			} 
			components[i].isSelected = isSelected; 
			if(components[i].child)
			{
				this.setSelectComponents(components[i].child,selectArray,newSelectArray);
			}
		}
		
	}


	// var slotTop=(<div><Button type="primary">Hello<i class="fa fa-database"></i></Button><i class="fa fa-database"></i></div>)

	onHelp = (p1, p2) => {

		alert("收到事件了" + p1 + p2);
	}
	onSelectComponent = (item) => {
		console.log("收到组件：" + item.alias);
		this.sendEvent("selectComponent", item);
		this.onRefresh(); 
	}
	
	
	connectWebSocket=(url)=>{
		this.wsUrl=url;
		// 指定websocket路径
		this.websocket = new WebSocket(url);
		
		this.websocket.onerror = ()=> {
			console.log("WebSocket连接发生错误");
			if(this.wsUrl)
			{
				this.websocket = new WebSocket(this.wsUrl);
				this.keepAlive(); 
			}
			
		}; 
		
		this.websocket.onopen = ()=> {
			console.log("WebSocket连接成功"); 
			// 保持这个链接
			this.keepAlive(); 
		}
		
		//接收到消息的回调方法
		this.websocket.onmessage = (event)=> {
			console.log("收到消息："+event.data); 
			if(event.data&&event.data.indexOf("{")==0)
			{
				let data = JSON.parse(event.data);
				if(data&&data.action)
				{
					// appId:window.appId,
					// fromEditor:window.editorInfo,
					
					if(data.fromEditor!=window.editorInfo)
					{
						if(data.action=="removeAppPage")
						{
							this.sendEvent("socketRemoveAppPage",data.item);
						} 
						
						if(data.action=="createNewPage")
						{
							this.sendEvent("socketCreateNewPage",data.item);
						} 
						
					}
					
					
					 
					
					 
				}
				else
				{
					this.sendEvent("socketMessage",event.data);
				} 
			} 
			if(event.data&&event.data.indexOf("协同人数：")==0)
			{
			 	this.sendEvent("xietongUsers",event.data);
			} 
			 
		}
		
		//连接关闭的回调方法
		this.websocket.onclose = ()=> {
			console.log("WebSocket连接关闭");
		}
		
		//监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
		window.onbeforeunload = ()=> {
			this.websocket.close();
		}
	}
	 
  
	keepAlive=()=> {
		
	
		if (this.wstimer) {
			clearTimeout(this.wstimer);
		}
		this.websocket.send("heart");
		// 
		this.wstimer = setTimeout(this.keepAlive, 3000);
	}
	 
	
	
	onTabClick=(key,e)=>{
		
		this.state.showCenterPage = key;
		this.state.controller.showCenterPage = key;
		
		if(key=='source')
		{
			this.sendEvent("showVueSource",true);
		}
		this.refresh();
		
		// if(key=='huabu')
		// {
			
		// }
		// if(key=='data')
		// {
			
		// }
		// if(key=='source')
		// {
			
		// }
	}

	render() {
		if(window.fileUrl)
		{
			window.fileUrl=window.fileUrl.replace("http:",document.location.protocol);
			window.fileUrl=window.fileUrl.replace("https:",document.location.protocol);
			
		}
		
		if(this.state.appNotExists)
		{
		return <div style={{width:'100%',height:'100%',textAlign:'center',paddingTop:'300px'}}>应用不存在，可能已被移除或删除！</div>
		}
		
		if(!this.state.mainInfo||this.state.vueloadedCount!==this.fileCount|| typeof window.KeeVue!='function')
		{
			return <div style={{width:'100%',height:'100%',textAlign:'center',paddingTop:'300px'}}><Spin tip="初始化编辑器...">
			    
			  </Spin></div>
		}
		else
		{
			
			$("#loading-box").removeClass("loading-box-show");
			$("#loading-box").addClass("loading-box-hidden");
			setTimeout(()=>{
				$("#loading-box").hide();
			},2000);
			
			// 
			if(window.mainVueApp)
			{
					 
			}
			else
			{
						 
						//  window.mainVueApp.sendEvent("vueCurrentUrl",url);
						setTimeout(()=>{
							if(window.loadVueApp)
							{
								
								window.loadVueApp();
							}
							else
							{
								setTimeout(()=>{
									if(window.loadVueApp)
									{
										window.loadVueApp();
									} 
								},50)
							} 
						},20)
						
			}
		}

		
		var top='60px';
		//var left = '300px';
		let right = this.state.right;
		
		let left = this.state.left;
		var bottom = '40px';
		var borderColor = "#fff";
			
		var centerSlot = (this.state.keePage!=null&&<FsBuildCenter components={this.state.components} keePage={this.state.keePage} 
		controller={this.state.controller} showCenterPage={this.state.showCenterPage} debug={true}></FsBuildCenter>);
		var leftSlot = null; 
		var rightSlot=null; 
		var topSlot = null;
		
		if(!window.isActivity&&!window.isReport)
		{
			leftSlot = (<FsBuildLeft components={this.state.components} onSelectComponent={this.onSelectComponent} appid={this.state.appId}></FsBuildLeft>);
			if(this.state.keePage)
			{
				rightSlot = <FsComponentPropertyRight keePage={this.state.keePage} targetComponent={this.state.targetComponent} po={this.state.targetComponent} controller={this.state.controller} ></FsComponentPropertyRight>
				topSlot = (<div ref={this.myRef}><FsBuildTop components={this.state.components} keePage={this.state.keePage} controller={this.state.controller} onHelp={this.onHelp} ref={(node) => this.b = node}  ></FsBuildTop></div>);
				
			}
			else
			{
				let blankPage = {};
				topSlot = (<div ref={this.myRef}><FsBuildTop components={this.state.components} keePage={blankPage} controller={this.state.controller} onHelp={this.onHelp} ref={(node) => this.b = node}  ></FsBuildTop></div>);
				
			}
			
		}
		
		if(window.isActivity)
		{
			// left = '386px';
			// right="500px";
			leftSlot = (<FsBuildLeftActivity components={this.state.components} onSelectComponent={this.onSelectComponent} appid={this.state.appId}></FsBuildLeftActivity>);
		 
			if(this.state.keePage)
			{
				rightSlot = (<FsComponentPropertyRightActivity keePage={this.state.keePage} targetComponent={this.state.targetComponent} po={this.state.targetComponent} controller={this.state.controller} ></FsComponentPropertyRightActivity>);
				topSlot =(<div ref={this.myRef}><FsBuildTopActivity components={this.state.components} keePage={this.state.keePage} controller={this.state.controller} onHelp={this.onHelp} ref={(node) => this.b = node}  ></FsBuildTopActivity></div>);
			}
			
		}
		
		if(window.isReport )
		{
			leftSlot = (<FsBuildLeft components={this.state.components} onSelectComponent={this.onSelectComponent} appid={this.state.appId}></FsBuildLeft>);
			
			if(this.state.keePage)
			{
				rightSlot= <FsComponentPropertyRightReport keePage={this.state.keePage} targetComponent={this.state.targetComponent} po={this.state.targetComponent} controller={this.state.controller} ></FsComponentPropertyRightReport>
				topSlot = (<div ref={this.myRef}><FsBuildTopReport components={this.state.components} keePage={this.state.keePage} controller={this.state.controller} onHelp={this.onHelp} ref={(node) => this.b = node}  ></FsBuildTopReport></div>);
						
			}
			
		}
 

 
	  
	  
	  let mainClassName=this.state.clientConfig.mainClassName;
	  
		return (
			<div >

			  
				
				<div    className={`${mainClassName} main-container`} 
				onMouseMove={(e)=>{this.sendEvent("mousemove",e)}}>
					{!window.isReport&&!window.isActivity&&<div className={`editor-main-logo`} >
					<img  src="./logo_2.png" style={{width:'36px',height:'34px'}}/>
					</div> 
					}
					
					
					 <div className={`kee-top-part`}   style={{height: '60px',left:(window.isReport||window.isActivity?0:'60px'),borderBottom:borderColor!=null?'1px solid '+borderColor:'none' }} >
					 				{topSlot}
					 </div>
					 
					 <div className={`kee-left-part`} id="leftPartDiv" style={{width:left!=null?left:'0px',top:top!=null?top:'0',bottom:0,borderRight:borderColor!=null?'1px solid '+borderColor:'none'}}>
					 	{leftSlot}
						<div className={`kee-left-part-rsizer`}></div>
					 </div>
					 
					 <div  className={`kee-center-part`}  style={{'left':left!=null?left:'0','top':top!=null?top:'0','right':right!=null?right:'0',  'bottom':bottom!=null?bottom:'0',background: '#EEEEEE'}}>
						 {centerSlot}
					 </div> 
							 
						 
						 <div className={`kee-right-part`} id="rightPartDiv"  style={{width:right!=null?right:'0px',top:top!=null?top:'0',bottom:0}}  >
						 	<div className={`kee-right-part-left-resizer`} ></div>
								{rightSlot}
						 </div>
						 
						 <div  className={`kee-bottom-part`}   style={{position:'absolute',zIndex:0,left:left,right:right,height:'40px',bottom:0}}  >
							<div style={{marginTop:'-15px'}}>
						 		    <Tabs tabPosition='bottom' onTabClick={this.onTabClick} activeKey={this.state.controller.showCenterPage}  >
						 		          <TabPane tab="画布" key="huabu">
						 		           
						 		          </TabPane>
										  
										  {
											  !window.isReport&&!window.isActivity &&  <TabPane tab="数据" key="data">
											    
											  </TabPane>
										  }
						 		          {
						 		          	!window.isReport&&!window.isActivity &&<TabPane tab="交互代码" key="source">
						 		          											    
						 		          	</TabPane>
						 		          }
						 		          
										  
						 		     </Tabs>
							</div>
						 </div>
						 
							
				</div>
			 




				<FsWinManager debug={false}></FsWinManager>
				
				<FsRightDrawer></FsRightDrawer>

				<FsDrager></FsDrager>
				<KinerGuideView   guideStep={0} />
				
			</div>



		);
	}

}

export default FsBuild;
